import { Button, ButtonProps } from "@mui/material";
import classNames from "classnames";

import { LoadingButtonContainer, LoadingButtonSpinner, LoadingButtonSpinnerContainer } from "./LoadingButton.styles";

interface IProps extends ButtonProps {
  color?: ButtonProps["color"];
  disabled?: ButtonProps["disabled"];
  fullWidth?: ButtonProps["fullWidth"];
  /**
   * If `true`, the component displays a loading spinner and is disabled.
   * @default false
   */
  loading?: boolean;
  variant?: ButtonProps["variant"];
}

/**
 * Button used to fire actions & indicate to the user something is loading in the background.
 */
const LoadingButton: React.FC<IProps> = ({ loading = false, children, className, fullWidth, disabled, onClick, ...rest }: IProps) => {
  return (
    <LoadingButtonContainer
      className={classNames(className, {
        "full-width": fullWidth,
      })}
    >
      <Button variant="contained" fullWidth={fullWidth} disabled={loading || disabled} onClick={onClick} {...rest}>
        {children}
      </Button>
      {loading && (
        <LoadingButtonSpinnerContainer>
          <LoadingButtonSpinner />
        </LoadingButtonSpinnerContainer>
      )}
    </LoadingButtonContainer>
  );
};

export default LoadingButton;
